"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCustomerAddress = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const common_types_1 = require("@as-react/common-types");
const getAddressThirdLineByCountry = (address, country) => {
    if (!address.city && !address.postCode) {
        return null;
    }
    switch (address.country) {
        case 'AU':
        case 'NZ':
            return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [address.city, " ", address.postCode, ", ", country] }));
        case 'GB':
        case 'GG':
        case 'JE':
            return [address.city, address.county, address.postCode, country].filter(Boolean).map((item, index, arr) => ((0, jsx_runtime_1.jsxs)(react_1.Fragment, { children: [item, index !== arr.length - 1 && (0, jsx_runtime_1.jsx)("br", {})] }, item.replace(/ /g, ''))));
        case 'US':
            return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [address.city, ", ", address.county, " ", address.postCode, ", ", country] }));
        default:
            return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [address.postCode, " ", address.city, ", ", country] }));
    }
};
const getAddressStreetInfoByCountry = (address, t) => {
    const houseNumberAddition = address &&
        !!address.houseNumberAddition &&
        `${t(address.idCountry === common_types_1.CountryId.NL ? '' : 'account:delivery.bus')} ${address.houseNumberAddition}`;
    const streetInfoComponents = [
        address.address,
        address.houseNumber,
        address.addressLine2,
        address.addressLine3,
        address.addressLine4,
        houseNumberAddition,
    ].filter(Boolean);
    switch (address.country) {
        case 'GB':
        case 'GG':
        case 'JE':
            return streetInfoComponents.map((street, index, arr) => ((0, jsx_runtime_1.jsxs)(react_1.Fragment, { children: [street, index !== arr.length - 1 && (0, jsx_runtime_1.jsx)("br", {})] }, street.replace(/ /g, ''))));
        default: {
            return streetInfoComponents.join(' ');
        }
    }
};
const getCustomerAddress = (address, country, t) => {
    const streetInfo = getAddressStreetInfoByCountry(address, t);
    const cityInfo = getAddressThirdLineByCountry(address, country);
    if (streetInfo && cityInfo) {
        return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [streetInfo, (0, jsx_runtime_1.jsx)("br", {}), cityInfo] }));
    }
    if (streetInfo) {
        return streetInfo;
    }
    if (cityInfo) {
        return cityInfo;
    }
    return null;
};
exports.getCustomerAddress = getCustomerAddress;
